"use client";

import { useComponentLifecycle } from "@stadium/hooks/lib/use-component-lifecycle";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { StripeWrapper } from "@stadium/services/stripe";
import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import ZendeskIconPositionAdjuster from "@stadium/services/zendesk/icon-position-adjuster";

import { STRIPE_API_KEY } from "@constants/env-variables";

import Checkout from "@components/store/checkout";
import { useStoreContext } from "@components/store/provider";
import CheckoutProvider from "@contexts/checkout-context";
import { CurrentUserContext } from "@contexts/current-user-provider";
import { getCartOrder, getCartOrderFetched } from "@selectors/cart";
import { getStoreBalance } from "@selectors/store";
import GlobalCheckoutProvider from "@stadium/checkout/src/contexts/checkout";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import { useWorkspaceContext } from "@contexts/workspace-context";

import { updateCartOrder } from "@slices/cart";

import { ZENDESK_POSITION_BOTTOM } from "@constants/app-defaults";
import { CART_RESPONSE_TYPE } from "@constants/orders/cart";
import { CHECKOUT_SOURCE_KEY } from "@constants/orders/checkout";

const emptyObj = {};

const CheckoutIndex = ({ parsedCookies = emptyObj, cmsSectionIndex }) => {
  const { workspaceSlug } = useWorkspaceContext();

  const dispatch = useDispatch();
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { setPageState, resetPageState } = useStoreContext();

  const { currentUserData } = useContext(CurrentUserContext);
  const storeSpecificBalance = useSelector(getStoreBalance);
  const orderData = useSelector(getCartOrder);
  const orderFetched = useSelector(getCartOrderFetched);

  const postOrderUpdateCallback = (order) => dispatch(updateCartOrder(order));

  useComponentLifecycle({ onUnmount: resetPageState });

  useEffect(() => {
    setPageState((state) => ({
      ...state,
      withMenu: false,
      withSearch: false,
      source: CHECKOUT_SOURCE_KEY,
      parsedCookies,
      withCart: false,
      showFooter: false,
      showTalkToSalesCta: false,
    }));
  }, [parsedCookies]);

  return (
    <ZendeskIconPositionAdjuster bottomOffset={ZENDESK_POSITION_BOTTOM}>
      <GlobalCheckoutProvider
        isSelfOrder
        currentUserData={currentUserData}
        storeSpecificBalance={storeSpecificBalance}
        orderData={orderFetched ? orderData : emptyObj}
        postOrderUpdateCallback={postOrderUpdateCallback}
        orderResponseType={CART_RESPONSE_TYPE}
        workspaceSlug={workspaceSlug}
      >
        <StripeWrapper stripeKey={STRIPE_API_KEY}>
          <BottomIconHideWrapper hideIcon={isMobileDevice}>
            <CheckoutProvider canShowCartUpdatedMessage>
              <Checkout cmsSectionIndex={cmsSectionIndex} />
            </CheckoutProvider>
          </BottomIconHideWrapper>
        </StripeWrapper>
      </GlobalCheckoutProvider>
    </ZendeskIconPositionAdjuster>
  );
};

export default CheckoutIndex;
